<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/navigator/bbs/bbsNav' }">{{ serviceMsg.serviceName }}</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/navigator/bbs/bbsNav/microCommunity' }">{{serviceMsg.children[0].type === 15 ? serviceMsg.children[0].serviceName : serviceMsg.children[1].serviceName }}</el-breadcrumb-item>
      <el-breadcrumb-item>话题详情</el-breadcrumb-item>
    </el-breadcrumb>
    
    <!-- 帖子内容 -->
    <div class="postContent boxShadow" v-loading="loading2">
      <div class="header">
        <img :src="postInfo.userIcon" alt="">
        <div class="user">
          <p class="textOver">{{ postInfo.userName }}</p>
          <p class="textOver">{{ postInfo.position }}</p>
        </div>
        <div class="icons">
          <span>
            <i class="iconfont icon-dianzan" :class="{ 'isLikes': postInfo.isLikes }" @click="selectLike(postInfo.id)"></i>
            &nbsp;&nbsp;{{ postInfo.likes }}
          </span>
          <span class="iconfont icon-pinglun">&nbsp;&nbsp;{{ allCommentTotal }}</span>

          <!-- JiaThis Button BEGIN -->
          <!-- <div class="jiathis_style_32x32">
            <a class="jiathis_button_qzone"></a>
            <a class="jiathis_button_tsina"></a>
            <a class="jiathis_button_tqq"></a>
            <a class="jiathis_button_weixin"></a>
            <a class="jiathis_button_renren"></a>
            <a href="http://www.jiathis.com/share" class="jiathis jiathis_txt jtico jtico_jiathis" target="_blank"></a>
            <a class="jiathis_counter_style"></a>
          </div>
          <script type="text/javascript" src="http://v3.jiathis.com/code/jia.js" charset="utf-8"></script> -->
          <!-- JiaThis Button END -->
          <!-- <span class="iconfont icon-fenxiang">&nbsp;&nbsp;分享</span> -->
          <span class="iconfont icon-shanchu" @click="delPost(postInfo.id, postInfo.subject)" v-if="user.userId === postInfo.userId">&nbsp;&nbsp;删除</span>
        </div>
      </div>

      <h3 class="title">{{ postInfo.subject }}</h3>
      <p class="time">{{ postInfo.createTime | DateFilter('yyyy-MM-dd hh:mm:ss') }}</p>
      <div class="text" v-html="postInfo.content" ref="text">

      </div>
      <div class="circleIcon" :class="{ 'isLikes': postInfo.isLikes }" @click="selectLike(postInfo.id)">
          <i class="iconfont icon-dianzan"></i>
      </div>
    </div>

    <!-- 评论 -->
    <div class="comment boxShadow clearfix">
      <div class="input">
        <h3>评论</h3>
        <el-input type="textarea" :rows="3" placeholder="说点什么..." v-model="commentsContent" :disabled="!token"></el-input>
        <p v-if="!token">请先<span class="login" @click="showLogin = true">登录</span>，再发表评论！</p>
        <el-button size="small" type="primary" v-if="token" @click="commentsPost">评 论</el-button>
      </div>
      <div class="allComment" v-loading="loading">
       <p>
          <span :class="{'selectComments' : selectComments}" @click="selectCommentsIndex(1)">全部评论</span>
          <i class="num">({{ allCommentTotal }}条)</i>
          <i>|</i>
          <span :class="{'selectComments' : !selectComments}" @click="selectCommentsIndex(2)">我的评论</span>
       </p>
       <!-- 所有评论 -->
        <ul v-if="selectComments">
          <li v-for="(item,index) in allCommentList" :key="index" class="clearfix">
            <img :src="item.userIcon" alt="">
            <div class="right">
              <p class="name">
                <span>{{ item.userName }}</span>
                <span>{{ item.createTime | DateFilter('yyyy-MM-dd hh:mm:ss') }}</span>
              </p>
              <p class="content">
                {{item.content}}
              </p>
              <div class="icons">
                <span class="iconfont icon-shanchu" @click="delComment(item.id)" v-if="user.userId === item.userId"></span>
                <span>
                  <i class="iconfont icon-dianzan" :class="{ 'isLikes': item.isLikes }" @click="selectLikeComment(item.id, index)"></i>
                  &nbsp;&nbsp;{{ item.likes }}
                </span>
              </div>
            </div>
          </li>
          <p class="more" @click="getCommentsList" v-show="this.allCommentList.length !== this.allCommentTotal">查看更多评论</p>
          <p class="more noMore" v-show="this.allCommentList.length && this.allCommentList.length === this.allCommentTotal">-- 我是有底线的 --</p>
          <p class="more noMore" v-show="!this.allCommentList.length">-- 暂无评论 --</p>
        </ul>
        <!-- 我的评论 -->
        <ul v-if="!selectComments">
          <li v-for="(item,index) in myCommentList" :key="index" class="clearfix">
            <img :src="item.userIcon" alt="">
            <div class="right">
              <p class="name">
                <span>{{ item.userName }}</span>
                <span>{{ item.createTime | DateFilter('yyyy-MM-dd hh:mm:ss') }}</span>
              </p>
              <p class="content">
                {{item.content}}
              </p>
              <div class="icons">
                <span class="iconfont icon-shanchu" @click="delComment(item.id)" v-if="user.userId === item.userId"></span>
                <span>
                  <i class="iconfont icon-dianzan" :class="{ 'isLikes': item.isLikes }" @click="selectLikeComment(item.id, index)"></i>
                  &nbsp;&nbsp;{{ item.likes }}
                </span>
              </div>
            </div>
          </li>
          <p class="more" @click="getMyComments" v-show="this.myCommentList.length !== this.myCommentTotal">查看更多评论</p>
          <p class="more noMore" v-show="this.myCommentList.length && this.myCommentList.length === this.myCommentTotal">-- 我是有底线的 --</p>
          <p class="more noMore" v-show="!this.myCommentList.length">-- 暂无评论 --</p>
        </ul>

      </div>
    </div>

    <!-- 弹窗登录 -->
    <MaskLogin v-show='showLogin' @close='showLogin = false'></MaskLogin>

    <!-- 消息弹框 -->
    <SubmitSuccess v-if='submitSuccessFlag' @close='submitSuccessFlag = false' class='submit-success' :tipsMsg="tipsMsg"></SubmitSuccess>


  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      bbb: '',
      postInfo: {},
      showLogin: false,
      submitSuccessFlag: false,
      tipsMsg: '',
      loading: false, 
      loading2: false,
      commentsContent: '',
      beginId: 0,  // 用于评论列表
      beginId2: 0, // 用于我的评论列表
      selectComments: true,
      allCommentTotal: '',  // 评论总数
      myCommentTotal: '',  // 我的评论总数
      allCommentList: [],  // 总评论列表
      myCommentList: [],   // 我的评论列表
      serviceMsg: {},
    }
  },
  created() {
     this.serviceMsg = this.parkServiceList.find((val) => {
      return val.serviceFlag === 8;
    });
    this.getPostInfo();
    this.getCommentsList();
  },
  computed: {
    ...mapGetters(['currentParkId', 'token', 'user', 'parkServiceList']),
  },
  methods: {
    selectCommentsIndex(type) {
      if (type === 1) {
        this.selectComments = true;
        this.beginId = 0;
        this.allCommentList = [];
        this.getCommentsList();
      } else if (type === 2) {
        this.selectComments = false;
        this.beginId2 = 0;
        this.myCommentList = [];
        this.getMyComments();
      }
    },
    getPostInfo() {  // 获取帖子内容
      this.loading2 = true;
      setTimeout(() => {
        this.loading2 = false;
      }, 5000);     
      this.$http.post(`${this.URL_PREFIX}/app/get/bbs/post/detail`, {
        id: this.$route.params.id,
      }, {
        headers: { token: this.token },
      }).then((response) => {
        const res = response.data;
        this.loading2 = false;
        if (res.resCode === '10000') {
          this.postInfo = res.resData;
        }
      });
    },
    selectLike(id) {  // 点赞
      if (!this.token) {
        this.showLogin = true;
        return;
      }
      this.$http.post(`${this.URL_PREFIX}/app/opt/bbs/likes/log`, {
        postId: id,
      }, {
        headers: { token: this.token },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.postInfo.isLikes = !this.postInfo.isLikes;
          if (this.postInfo.isLikes) {
            this.postInfo.likes++;
          } else {
            this.postInfo.likes--;
          }
        }
      });
    },
    delPost(id, title) {
      if (!this.token) {
        this.showLogin = true;
        return;
      }
      this.$confirm(`确定删除帖子：${title}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post(`${this.URL_PREFIX}/app/delete/bbs/post`, {
          id: id,
        }, {
          headers: { token: this.token },
        }).then((response) => {
          const res = response.data;
          this.submitSuccessFlag = true;
          if (res.resCode === '10000') {
            this.tipsMsg = '删帖成功！';
            this.$router.push({ path: '/navigator/bbs/bbsNav' });
          } else {
            this.tipsMsg = res.resDesc;
          }
        });
      }).catch(()=> {});;
    },
    commentsPost() {  // 评论
      if (!this.token) {
        this.showLogin = true;
        return;
      }
      if (!this.commentsContent) {
        this.submitSuccessFlag = true;
        this.tipsMsg = '请填写评论内容！';
        return;
      }
      this.$http.post(`${this.URL_PREFIX}/app/added/bbs/comments`, {
        postId: this.$route.params.id,
        content: this.commentsContent,
      }, {
        headers: { token: this.token },
      }).then((response) => {
        const res = response.data;
        this.submitSuccessFlag = true;
        if (res.resCode === '10000') {
          this.tipsMsg = '评论成功！';
          this.commentsContent = '';
          this.reset();
        } else {
          this.tipsMsg = res.resDesc;
        }
      });
    },
    getCommentsList() {  // 评论列表
      if (this.allCommentList.length === this.allCommentTotal) return;
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);      
      this.$http.post(`${this.URL_PREFIX}/app/get/bbs/post/detail/allcomments`, {
        postId: this.$route.params.id,
        parkId: this.currentParkId,
        beginId: this.beginId,
        currPage: 1,
        pageRows: 2 ,
      }, {
        headers: { token: this.token },
      }).then((response) => {
        const res = response.data;
        this.loading = false;
        if (res.resCode === '10000') {
          this.allCommentTotal = res.resData.pageInfo ? res.resData.pageInfo.total : 0;
          const arr = res.resData.pageList ? res.resData.pageList : [];
          this.allCommentList = arr.length ? this.allCommentList.concat(arr) : arr;
          this.beginId = this.allCommentList.length ? this.allCommentList[this.allCommentList.length -1].id : 0;
        }
      });
    },
    selectLikeComment(id, index) {  // 点赞评论
      if (!this.token) {
        this.showLogin = true;
        return;
      }
      this.$http.post(`${this.URL_PREFIX}/app/opt/bbs/likes/comments`, {
        id: id,
      }, {
        headers: { token: this.token },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          if (!this.selectComments) {
            this.myCommentList[index].isLikes = !this.myCommentList[index].isLikes;
            if (this.myCommentList[index].isLikes) {
              this.myCommentList[index].likes++;
            } else {
              this.myCommentList[index].likes--;
            }
          } else {
            this.allCommentList[index].isLikes = !this.allCommentList[index].isLikes;
            if (this.allCommentList[index].isLikes) {
              this.allCommentList[index].likes++;
            } else {
              this.allCommentList[index].likes--;
            }
          }
        }
      });
    },
    reset() {
      this.beginId = 0;
      this.allCommentList = [];
      this.allCommentTotal ='';
      this.beginId2 = 0;
      this.myCommentList = [];
      this.myCommentTotal = '';
      this.getMyComments();
      this.getCommentsList();
    },
    delComment(id) {  // 删除评论
      if (!this.token) {
        this.showLogin = true;
        return;
      }
      this.$confirm('确定删除该评论?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post(`${this.URL_PREFIX}/app/delete/bbs/comments`, {
          id: id,
        }, {
          headers: { token: this.token },
        }).then((response) => {
          const res = response.data;
          this.submitSuccessFlag = true;
          if (res.resCode === '10000') {
            this.tipsMsg = '删除成功！';
            this.reset();
          } else {
            this.tipsMsg = res.resDesc;
          }
        });
      }).catch(()=> {});
    },
    getMyComments() {
      if (this.myCommentList.length === this.myCommentTotal) return;
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);      
      this.$http.post(`${this.URL_PREFIX}/app/get/bbs/post/detail/mycomments`, {
        postId: this.$route.params.id,
        parkId: this.currentParkId,
        beginId: this.beginId2,
        currPage: 1,
        pageRows: 2 ,
      }, {
        headers: { token: this.token },
      }).then((response) => {
        const res = response.data;
        this.loading = false;
        if (res.resCode === '10000') {
          this.myCommentTotal = res.resData.pageInfo ? res.resData.pageInfo.total : 0;
          const arr = res.resData.pageList ? res.resData.pageList : [];
          this.myCommentList = arr.length ? this.myCommentList.concat(arr) : arr;
          this.beginId2 = this.myCommentList.length ? this.myCommentList[this.myCommentList.length -1].id : 0;
        }
      });
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~@scss';

// 帖子内容
.postContent {
  background-color: #fff;
  padding-bottom: 30px;
  margin-bottom: 20px;
  .header {
    height: 60px;
    background-color: #ebebeb;
    display: flex;
    padding: 0 20px;
    align-items: center;
    img {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        margin-right: 16px;
        border: 1px solid #f6f6f6;
        box-sizing: border-box;
      }
    .user {
      flex: 1;
      p {
        width: 300px;
        line-height: 16px;
        font-size: 10px;
        color: #666;
      } 
    }
  }
  .title {
    margin-top: 24px;
    padding: 0 20px;
    text-align: center;
    font-size: 20px;
    color: #333;
  }
  .time {
    text-align: center;
    font-size: 12px;
    color: #666;
    line-height: 30px;
  }
  .text {
    padding: 24px 40px;
    min-height: 100px;
    overflow: hidden;
  }
  .circleIcon {
    width: 60px;
    cursor: pointer;
    height: 60px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    border: 1px solid #ccc;
    color: #fff;
    background-color: #ccc;
    &.isLikes {
      background-color: $color-red;
    }
    i {
      font-size: 20px;
    }
  }
}

// 评论
.comment {
  padding: 40px;
  padding-bottom: 0;
  position: relative;
  margin-bottom: 20px;
  background-color: #fff;
  .input {
    h3 {
      font-size: 16px;
      color: #333;
      font-weight: 600;
      margin-bottom: 10px;
    }
    p {
      position: absolute;
      top: 100px;
      left: 50%;
      transform: translateX(-50%);
      .login {
        text-decoration: underline;
        cursor: pointer;
        margin: 0 2px;
      }
    }
    .el-button {
      float: right;
      width: 80px;
      height: 36px;
      margin-top: 28px;
      font-weight: 600;
      font-size: 14px;
    }
  }
  .allComment {
    margin-top: 88px;
    >p {
      margin-bottom: 20px;
      span {
        cursor: pointer;
        font-size: 16px;
        font-weight: 600;
        &.selectComments {
          color: red; 
        }
      }
      i {
        font-style: normal;
        font-size: 16px;
        color: #bbb;
        margin: 0 4px;
        &.num {
          color: #bbb;
          font-size: 12px;
        }
      }
    }
    ul {
      li {
        min-height: 88px;
        padding: 14px 0;
        border-top: 2px solid #f6f6f6;
        display: flex;
        &:last-of-type {
          border-bottom: 2px solid #f6f6f6;
        }
        img {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          border: 1px solid #f6f6f6;
          box-sizing: border-box;
          margin-right: 10px;
        }
        .right {
          flex: 1;
          .name span {
            font-size: 12px;
            color: #666;
            margin-right: 20px;
          }
          .content {
            margin-top: 10px;
            font-size: 14px;
            color: #666;
            line-height: 20px;
          }
          .icons {
            float: right;
            width: 120px;
            margin-top: 10px;
            span:last-of-type {
              margin-left: 30px;
            }
          }
        }
      }
      .more {
        text-align: center;
        font-size: 14px;
        color: $color-red;
        margin: 24px 0;
        cursor: pointer;
        &.noMore {
          color: #ccc;
          cursor: auto;
        }
      }
    }
  }
}
// 图标
.icons {
  width: 200px;
  display: flex;
  span {
    flex: 1;
    display: inline-block;
    font-size: 14px;
    text-align: right;
    color: #666;
    &.iconfont {
      font-size: 16px;
    }
    .iconfont {
      font-size: 16px;
    }
    &.icon-shanchu {
      cursor: pointer;
    }
    i {
      cursor: pointer;
    }
    &:last-of-type() {
      margin-right: 0;
    }
    .isLikes {
      color: $color-main;
    }
    &.icon-pinglun {
      cursor: auto;
    }
  }
}

.submit-success {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>




// WEBPACK FOOTER //
// src/pages/navigator/bbs/microCommunity/PostContent.vue